/*
 * @Author: liguokang
 * @Date: 2021-05-31 13:48:39
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-03 19:43:50
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */
const modalModule = {
  state: {
    info: {
      alert: false,
      confirm: false,
      title: '',
      message: '',
      okText: '',
      cancleText: '',
      showCancle: true,
      onResolve: () => {},
      onReject: () => {},
    },
  },
  mutations: {
    showAlert(state, payload) {
      payload.alert = true;
      payload.confirm = false;
      Object.assign(state.info, payload);
    },

    showConfirm(state, payload) {
      payload.alert = false;
      payload.confirm = true;
      Object.assign(state.info, payload);
    },
    hideModal(state, payload) {
      payload.alert = false;
      payload.confirm = false;
      payload.onResolve = () => {};
      payload.onReject = () => {};
      state.info = payload;
    },
  },
  actions: {
    showAlert({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        payload.onResolve = resolve;
        payload.onReject = reject;
        commit('showAlert', payload);
      });
    },

    showConfirm({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        payload.onResolve = resolve;
        payload.onReject = reject;
        commit('showConfirm', payload);
      });
    },
    onOk({ commit, state }, payload) {
      state.info.onResolve();
      commit('hideModal', {});
    },
    onCancel({ commit, state }, payload) {
      state.info.onReject();
      commit('hideModal', {});
    },
  },
  getters: {},
};

export default modalModule;



// WEBPACK FOOTER //
// ./src/store/modules/modal.js